var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    fillOpacity: 0.635,
    d: "M49.837 79.559L68.845 79.559 63.037 67.943 68.845 56.357 49.837 56.357 49.837 79.559",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M49.837 79.559L57.405 63.162 49.837 67.533 49.837 79.559",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    fillOpacity: 0.635,
    d: "M24.171 79.559L5.163 79.559 10.971 67.943 5.163 56.357 24.171 56.357 24.171 79.559",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE88E",
    d: "M16.603 39.607L16.603 63.162 37.004 74.776 57.405 63.162 57.405 39.607 37.004 28.001",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E57467",
    d: "M40.832 44.917c.117.234.293.381.557.41l7.664 1.67-5.317 5.576c-.176.176-.264.41-.205.645l.949 7.71-7.139-3.193c-.205-.117-.469-.117-.674 0L29.57 60.96l.937-7.741c.029-.235-.059-.47-.235-.645l-5.316-5.587 7.692-1.659c.235-.029.44-.176.528-.41l3.828-7.269",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M24.171 79.559L16.603 63.162 24.171 67.533 24.171 79.559",
    transform: "translate(-444 -1618) translate(444 1606) translate(6.747 .267)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesRewards);
export default __webpack_public_path__ + "static/media/features-rewards.549a741e.svg";
export { ForwardRef as ReactComponent };